exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-directory-wrapper[data-v-7cca1a02]{width:100%;padding-bottom:10px}.reviews-list-title[data-v-7cca1a02]{font-weight:700}.rgwd-directory-top-badge[data-v-7cca1a02]{width:200px;height:200px;margin:auto;border-radius:50%;border:1px solid #ccc;text-align:center;margin-top:20px;margin-bottom:20px}.rgwd-directory-top-badge i[data-v-7cca1a02]{font-size:40px;margin-top:10px;margin-bottom:10px}.rgwd-directory-top-badge .rating-nr[data-v-7cca1a02]{font-size:70px;font-weight:700;padding-top:0;padding-bottom:0;line-height:92px}", ""]);

// exports
